import { render, staticRenderFns } from "./AssignPefCoach.vue?vue&type=template&id=316f6ca9&scoped=true&"
import script from "./AssignPefCoach.vue?vue&type=script&lang=js&"
export * from "./AssignPefCoach.vue?vue&type=script&lang=js&"
import style0 from "./AssignPefCoach.vue?vue&type=style&index=0&id=316f6ca9&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316f6ca9",
  null
  
)

export default component.exports